module.exports = __webpack_public_path__ + "img/img_road_1.e8aeebbf.png";